import React from "react";
import { Modal, Button } from "react-bootstrap";

function ProductDetailsModal({ show, onHide, selectedProduct, translations }) {
  const renderProductDetails = (product) => {
    const isPesticide = product.type === "PESTICIDE";

    return (
      <div>
        <h4>{product.name}</h4>
        <p className="text-muted">
          {isPesticide ? translations.pesticides : translations.fertilizers}
        </p>

        <hr />

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.description}:</strong>
          </div>
          <div className="col-md-8">{product.description}</div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.storageMethod}:</strong>
          </div>
          <div className="col-md-8">{product.storageMethod}</div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.formulation}:</strong>
          </div>
          <div className="col-md-8">{product.formulation}</div>
        </div>

        {isPesticide && (
          <div className="row mb-3">
            <div className="col-md-4">
              <strong>{translations.controlTarget}:</strong>
            </div>
            <div className="col-md-8">{product.controlTarget}</div>
          </div>
        )}

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.activeIngredient}:</strong>
          </div>
          <div className="col-md-8">{product.activeIngredient}</div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.activeConcentration}:</strong>
          </div>
          <div className="col-md-8">{product.activeConcentration}</div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.recommendedDose}:</strong>
          </div>
          <div className="col-md-8">{product.recommendedDose}</div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>{translations.applicationMethod}:</strong>
          </div>
          <div className="col-md-8">{product.applicationMethod}</div>
        </div>

        {!isPesticide && (
          <div className="row mb-3">
            <div className="col-md-4">
              <strong>{translations.benefit}:</strong>
            </div>
            <div className="col-md-8">{product.benefit}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{translations.productDetails}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedProduct ? (
          renderProductDetails(selectedProduct)
        ) : (
          <p>Carregando...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {translations.close}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProductDetailsModal;


